import { get, post, del } from 'aws-amplify/api';

// REST API client via Amplify v6. Returns { data: <parsed JSON> }.

const API_NAME = 'readingtrainer'; // matches amplify-config.js -> API.REST.readingtrainer

// Execute a REST call and return { data } from the parsed body
async function exec(operation) {
  const { body } = await operation.response;
  let data;
  try {
    data = await body.json();
  } catch {
    data = {};
  }
  return { data };
}

// GET /newsletters/status
export function newslettersStatusGet() {
  return exec(get({ apiName: API_NAME, path: '/newsletters/status' }));
}

// POST /newsletters/update/subscription
export function newslettersUpdateSubscriptionPost(params, body) {
  return exec(
    post({
      apiName: API_NAME,
      path: '/newsletters/update/subscription',
      options: { body }
    })
  );
}

// DELETE /client/delete
export function clientDeleteDelete() {
  return exec(del({ apiName: API_NAME, path: '/client/delete' }));
}

// POST /subscription/stripe/created
export function subscriptionStripeCreatedPost(params, body, additionalParams) {
  return exec(
    post({
      apiName: API_NAME,
      path: '/subscription/stripe/created',
      options: { body }
    })
  );
}
